import { LoadingActionButton } from '@components/LoadingActionButton/LoadingActionButton';
import dialogCss from '@lib/style/dialog.module.scss';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ActionButton } from '@pages/ActionButton';
import React from 'react';
import css from './ConfirmDialog.module.scss';

type ConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  /** Awaited by the confirm button, which shows `loadingText` meanwhile. */
  onConfirm: () => Promise<void>;
  title: string;
  children: React.ReactNode;
  confirmLabel: string;
  confirmVariant?: 'primary' | 'danger';
  loadingText?: string;
};

/**
 * Cancel / confirm dialog for a single destructive or irreversible action
 * (delete an API key, disconnect an account). The body is free-form so the
 * caller can name the thing being acted on with `<strong>`.
 */
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel,
  confirmVariant = 'danger',
  loadingText = 'Processing...',
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} className={dialogCss.dialog}>
      <DialogTitle className={dialogCss.dialogTitle}>{title}</DialogTitle>
      <DialogContent className={dialogCss.dialogContent}>
        <div className={css.confirmContent}>{children}</div>
      </DialogContent>
      <DialogActions className={dialogCss.dialogActions}>
        <ActionButton variant="secondary" onClick={onClose}>
          Cancel
        </ActionButton>
        <LoadingActionButton variant={confirmVariant} onClick={onConfirm} loadingText={loadingText}>
          {confirmLabel}
        </LoadingActionButton>
      </DialogActions>
    </Dialog>
  );
}
